var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('date-picker',_vm._g(_vm._b({attrs:{"query":_vm.dateValue},on:{"update:query":function($event){_vm.dateValue=$event},"change":_vm.handleSearch}},'date-picker',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }